import React from 'react';
import PropTypes from 'prop-types';
import { format } from 'date-fns';

const MobileDisplay = ({ date, day }) => (
  <span>
    <span className="date-list__dates date-list__dates--date">{date}</span>
    <span className="date-list__dates date-list__dates--day">{day}</span>
  </span>
);

MobileDisplay.propTypes = {
  date: PropTypes.string.isRequired,
  day: PropTypes.string.isRequired,
};

export default MobileDisplay;
